module.exports = __webpack_public_path__ + "static/intelligence-icon-d9fab78f59a9585ebd457abcdf4e059b.gif";